export default "__VITE_ASSET__9Kd9CCmh__"